import React from 'react';
import styled from 'styled-components';

const ThemeContainer = styled.div`
  text-align: center;
  border: 2px solid transparent;
  &:hover {
    border: 2px solid #EEE;
  }
  
  ${props => props.selected && `
    border: 2px solid #FFF;
    &:hover {
      border: 2px solid #FFF;
    }
  `}
  
  ${props => props.single && `
    border: 2px solid #FFF;
    &:hover {
      border: 2px solid #FFF;
    }
  `}
`;

const StyledTheme = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 178px;
  width: 150px;
  padding-bottom: 10px;
  margin: 10px;
  text-align: center;
  
  ${props => props.single && `
    height: 300px;
    width: 240px;
  `}
  
  ${props => props.theme.template && `
    background: url('/themes/${props.theme.template}.jpg') no-repeat center top scroll;
    background-size: contain;
    background-repeat: none;
  `}
`;

const ThemeLabel = styled.div`
  margin-bottom: 10px;
`;

const Theme = (props) => (
  <ThemeContainer {...props}>
    <StyledTheme {...props} />
    <ThemeLabel>{props.theme && props.theme.label}</ThemeLabel>
  </ThemeContainer>
);

export default Theme;



// WEBPACK FOOTER //
// ./src/Containers/Theme.js